/**
 * Push a status message into the app's aria-live region.
 *
 * Components call `announce("Submission Foo approved.")` after an action
 * completes. App.tsx wires a `<div role="status" aria-live="polite">` at
 * the root and listens for this event, so the message is read out to
 * screen-reader users without intrusive notification UI.
 *
 * Lives in its own module so test files for downstream components can
 * import the function without dragging in the full App tree (and the
 * Cognito SDK that App imports).
 */
export const ANNOUNCE_EVENT = 'moderation:announce';

export function announce(message: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(ANNOUNCE_EVENT, { detail: { message } }),
  );
}
